import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      component="footer"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        padding: '2px',
        background: 'var(--stat-progress2)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        textAlign: 'center',
        zIndex: 1000,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3 }}>
        <Link
          component="button"
          onClick={() => navigate('/legal')}
          sx={{
            color: 'white',
            textDecoration: 'none',
            fontSize: '0.7rem',
            opacity: 0.8,
            '&:hover': {
              opacity: 1,
              textDecoration: 'underline',
            },
          }}
        >
          {t('footer.legalLink')}
        </Link>
        <Link
          component="button"
          onClick={() => navigate('/faq')}
          sx={{
            color: 'white',
            textDecoration: 'none',
            fontSize: '0.7rem',
            opacity: 0.8,
            '&:hover': {
              opacity: 1,
              textDecoration: 'underline',
            },
          }}
        >
          {t('footer.faqLink')}
        </Link>
      </Box>
    </Box>
  );
};

export default Footer;
